var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { v4 as uuidv4 } from 'uuid';
import Popup from 'devextreme/ui/popup';
import { DinapsisChart } from './dinapsis-chart';
let DinapsisPopupChart = class DinapsisPopupChart extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * A property that is used to toggle the popup
         */
        this.togglePopup = false;
        /**
       * A property that is used to save the chart
       */
        this.chart = new DinapsisChart();
        /**
         * A property that is used to generate unique idPopupChart
         */
        this.idPopupChart = `container-popup-${uuidv4()}`;
        this.activeChartWindow = { showChart: true, showTable: false };
        /**
         * Property that set the height of the chart in the popup.
         */
        this.popupChartHeight = '66vh';
    }
    /**
     * This method is from the Lit lifecycle and is used to subscribe to the event
     */
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('open-popup-chart', (event) => {
            this.handlerActiveWindow(event);
        });
    }
    /**
     * This method handle the behaivor of the active window.
     * @param event event
     */
    handlerActiveWindow(event) {
        const { detail } = event;
        this.activeChartWindow = detail;
    }
    /**
     * This function creates a popup chart element with a specific ID.
     * @returns A div element with an id of `this.idPopupChart`.
     */
    createPopup() {
        return html `<div id="${this.idPopupChart}"></div>`;
    }
    /**
     * This function dispatches a custom event
     * with a boolean value indicating whether
     * a popup toggle is open or closed.
     */
    updateToggle() {
        this.dispatchEvent(new CustomEvent('update-toggle', { detail: { isOpened: this.togglePopup } }));
    }
    /**
     * This function initializes a popup container with a chart inside and sets various properties and
     * event handlers.
     */
    async initPopup() {
        const popupContainer = document.getElementById(this.idPopupChart);
        const self = this;
        const { titleIcon, title } = this.model;
        const icon = titleIcon
            ? `<span class="material-icons-round pop-up-icon">
          ${titleIcon}
        </span>`
            : '';
        const popup = new Popup(popupContainer, {
            width: '90vw',
            height: '90vh',
            visible: true,
            dragEnabled: false,
            showCloseButton: true,
            showTitle: true,
            toolbarItems: [{
                    html: `${icon}${title}`,
                    location: 'before',
                }],
            hideOnOutsideClick: true,
            contentTemplate: (container) => {
                // eslint-disable-next-line no-param-reassign
                container.style.overflow = 'auto';
                container.appendChild(self.chart);
            },
            onHidden: () => {
                // Set to false the popup handler
                this.togglePopup = false;
                this.updateToggle();
            },
            onShown: () => {
                // Resize chart to the popup container size
                self.chart.resizeChart();
            },
        });
        popup.show();
    }
    /**
     * The function updates a property of the model object to disallow popups.
     */
    updateModel() {
        // Always disable allowPopup
        this.model.allowPopup = false;
        // Check if showDateRangePopup is enabled or not
        this.checkDateRangeVisibility();
        // Refresh Chart model with Popup Chart model
        if (this.chart.model)
            this.chart.model = this.model;
    }
    /**
     * The function checks and update the model with showDateRangePopupMode value.
     */
    checkDateRangeVisibility() {
        const { showDateRangePopupMode } = this.model;
        this.model.showDateRange = showDateRangePopupMode !== null && showDateRangePopupMode !== void 0 ? showDateRangePopupMode : false;
    }
    /**
     * The function initializes a DinapsisChart object
     *  with a model and assigns it to a chart variable.
     */
    initChart() {
        const dChart = new DinapsisChart();
        dChart.setChartHeight(this.popupChartHeight);
        dChart.model = this.model;
        const { showTable, showChart } = this.validateActiveChartWindow();
        dChart.showTable = showTable;
        dChart.showChart = showChart;
        // Set the DateRangeOptions Parent
        dChart.dateRangeOptions = this.dateRangeOptions;
        // Watch date-range-change event
        dChart.addEventListener('date-range-change', this.emitEventOnDateRangeChange.bind(this));
        this.chart = dChart;
    }
    /**
     * The function emits a custom event with the detail provided when the date range changes.
     */
    emitEventOnDateRangeChange(ev) {
        const { detail } = ev;
        const { dateRange } = detail;
        this.dispatchEvent(new CustomEvent('date-range-change', { detail: dateRange }));
    }
    /**
     * This function validates the active chart window and returns whether to show the table or chart.
     * @returns An object with the properties `showTable` and `showChart`.
     */
    validateActiveChartWindow() {
        let { showTable } = this.activeChartWindow;
        const { showChart } = this.activeChartWindow;
        if (showTable && showChart)
            showTable = false;
        return { showTable, showChart };
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        if (changedProperties.has('togglePopup')) {
            if (this.togglePopup) {
                this.initChart();
                this.initPopup();
            }
        }
        if (changedProperties.has('model')) {
            this.updateModel();
        }
    }
    /**
   * The createRenderRoot function is a function that is called by the lit-html library to tell the
   * component where to render the html.
   * @returns The element itself.
   */
    createRenderRoot() {
        return this;
    }
    /**
   * The function returns a string of HTML that contains a div that contains the component.
   * @returns The return statement is returning the html template literal
   */
    render() {
        return this.createPopup();
    }
};
__decorate([
    state(),
    property({ type: Boolean })
], DinapsisPopupChart.prototype, "togglePopup", void 0);
__decorate([
    property({ type: Object })
], DinapsisPopupChart.prototype, "model", void 0);
__decorate([
    property({ type: Object })
], DinapsisPopupChart.prototype, "dateRangeOptions", void 0);
DinapsisPopupChart = __decorate([
    customElement('dinapsis-popup-chart')
], DinapsisPopupChart);
export { DinapsisPopupChart };
//# sourceMappingURL=dinapsis-popup-chart.js.map